/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import{q as s,o,g as r}from"../../../../../chunks/vec3.js";import{c,g as n}from"../../../../../chunks/sphere.js";const t=1e3;function e(t,e,a){const m=c(),p=n(m);return s(p,p,t,.5),s(p,p,e,.5),m[3]=o(p,t),r(p,p,a),m}export{e as boundsFromEdge,t as maxCandidateCount};
